import './tree-view.css';
export default {
  "badge": "pf-v5-c-badge",
  "dirRtl": "pf-v5-m-dir-rtl",
  "modifiers": {
    "compact": "pf-m-compact",
    "guides": "pf-m-guides",
    "expanded": "pf-m-expanded",
    "noBackground": "pf-m-no-background",
    "current": "pf-m-current",
    "read": "pf-m-read",
    "selectable": "pf-m-selectable",
    "truncate": "pf-m-truncate"
  },
  "themeDark": "pf-v5-theme-dark",
  "treeView": "pf-v5-c-tree-view",
  "treeViewAction": "pf-v5-c-tree-view__action",
  "treeViewContent": "pf-v5-c-tree-view__content",
  "treeViewListItem": "pf-v5-c-tree-view__list-item",
  "treeViewNode": "pf-v5-c-tree-view__node",
  "treeViewNodeCheck": "pf-v5-c-tree-view__node-check",
  "treeViewNodeContainer": "pf-v5-c-tree-view__node-container",
  "treeViewNodeContent": "pf-v5-c-tree-view__node-content",
  "treeViewNodeCount": "pf-v5-c-tree-view__node-count",
  "treeViewNodeIcon": "pf-v5-c-tree-view__node-icon",
  "treeViewNodeText": "pf-v5-c-tree-view__node-text",
  "treeViewNodeTitle": "pf-v5-c-tree-view__node-title",
  "treeViewNodeToggle": "pf-v5-c-tree-view__node-toggle",
  "treeViewNodeToggleIcon": "pf-v5-c-tree-view__node-toggle-icon",
  "treeViewSearch": "pf-v5-c-tree-view__search"
};